
import { defineComponent, ref, PropType } from 'vue';
import AddressPicker from '@/components/address-picker/index.vue';
import { IWarehousePageListItem } from '@/api/system-config/type.d';
import { updateWarehouse, addWarehouse } from '@/api/system-config/index';

export default defineComponent({
  name: 'warehouse-info-dialog',
  props: {
    warehouseInfoDialogVisible: {
      type: Boolean,
      default: false,
    },
    rowItem: {
      type: Object as PropType<IWarehousePageListItem>,
      default: () => {},
    },
    orderCode: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
  },
  emits: ['update:warehouseInfoDialogVisible', 'uploadList'],
  components: {
    AddressPicker,
  },
  setup(props, { emit }) {
    // 仓库选中项
    const choosedItem = ref<IWarehousePageListItem>(
      {
        address: '',
        area: '',
        city: '',
        code: '',
        name: '',
        province: '',
        sort: '',
        warehouseId: '',
      },
    );
    // 初始化
    const handleOpen = () => {
      choosedItem.value = {
        address: '',
        area: '',
        city: '',
        code: '',
        name: '',
        province: '',
        sort: '',
        warehouseId: '',
      };
      if (props.type === 'edit') {
        choosedItem.value = JSON.parse(JSON.stringify(props.rowItem));
      }
    };

    const refForm = ref(null);
    // 取消
    const handleCancel = () => {
      (refForm.value as any).resetFields();
      emit('update:warehouseInfoDialogVisible', false);
    };
    // 确认
    const confirmUpdate = async () => {
      try {
        await (refForm.value as any).validate();
        const {
          warehouseId,
          address,
          area,
          city,
          code,
          name,
          province,
          sort,
        } = choosedItem.value;
        const params = {
          warehouseId,
          address,
          area,
          city,
          code,
          name,
          sort,
          province,
        };
        if (props.type === 'add') {
          await addWarehouse(params);
        }
        if (props.type === 'edit') {
          await updateWarehouse(params);
        }
        emit('update:warehouseInfoDialogVisible', false);
        emit('uploadList');
      } catch (error) {
        console.log(error);
      }
    };

    return {
      handleCancel,
      choosedItem,
      handleOpen,
      confirmUpdate,
      refForm,
      rules: {
        name: [
          {
            required: true,
            message: '仓库名称不能为空',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '仓库编号不能为空',
            trigger: 'blur',
          },
        ],
        area: [
          {
            required: true,
            message: '仓库地址不能为空',
            trigger: 'blur',
          },
        ],
        province: [
          {
            required: true,
            message: '仓库地址不能为空',
            trigger: 'blur',
          },
        ],
        city: [
          {
            required: true,
            message: '仓库地址不能为空',
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '详细地址不能为空',
            trigger: 'blur',
          },
        ],
      },
    };
  },
});
